// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ja-2";
export var container = "_ja-4";
export var dismissButton = "_ja-3";
export var hasPaddingBottom = "_ja-6";
export var last = "_ja-e";
export var scrollbarThumb = "_ja-c";
export var scrollbarTrack = "_ja-b";
export var selected = "_ja-9";
export var spin = "_ja-1";
export var spinning = "_ja-0";
export var suggestionItem = "_ja-d";
export var suggestionsPanel = "_ja-5";
export var tonePill = "_ja-8";
export var tonesContainer = "_ja-7";
export var unselected = "_ja-a";